export var BusinessApiKeyScope;
(function (BusinessApiKeyScope) {
    BusinessApiKeyScope["AccountRead"] = "account:read";
    BusinessApiKeyScope["ContentRead"] = "content:read";
    BusinessApiKeyScope["ContentWrite"] = "content:write";
    BusinessApiKeyScope["Generate"] = "generate";
    BusinessApiKeyScope["Publish"] = "publish";
    BusinessApiKeyScope["BrandRead"] = "brand:read";
    BusinessApiKeyScope["BrandWrite"] = "brand:write";
    BusinessApiKeyScope["AnalyticsRead"] = "analytics:read";
})(BusinessApiKeyScope || (BusinessApiKeyScope = {}));
export const ALL_BUSINESS_API_KEY_SCOPES = Object.values(BusinessApiKeyScope);
export const BUSINESS_API_KEY_SCOPE_LABELS = {
    [BusinessApiKeyScope.AccountRead]: 'Account (read)',
    [BusinessApiKeyScope.ContentRead]: 'Content (read)',
    [BusinessApiKeyScope.ContentWrite]: 'Content (write)',
    [BusinessApiKeyScope.Generate]: 'AI generation',
    [BusinessApiKeyScope.Publish]: 'Approve & publish',
    [BusinessApiKeyScope.BrandRead]: 'Brand (read)',
    [BusinessApiKeyScope.BrandWrite]: 'Brand (write)',
    [BusinessApiKeyScope.AnalyticsRead]: 'Analytics (read)',
};
export const BUSINESS_API_KEY_SCOPE_DESCRIPTIONS = {
    [BusinessApiKeyScope.AccountRead]: 'Read the business profile, plan, credit balance, and connected channels',
    [BusinessApiKeyScope.ContentRead]: 'Read posts, the content calendar, ideas, autopilot state, and uploaded media',
    [BusinessApiKeyScope.ContentWrite]: 'Create and edit posts, unschedule, manage ideas and media uploads',
    [BusinessApiKeyScope.Generate]: 'Run AI generation and revision (draws from the business credit balance)',
    [BusinessApiKeyScope.Publish]: 'Schedule, approve, and publish posts to connected social accounts',
    [BusinessApiKeyScope.BrandRead]: 'Read the brand kit, brand card, and brand memories',
    [BusinessApiKeyScope.BrandWrite]: 'Edit the brand kit, brand card, and brand memories',
    [BusinessApiKeyScope.AnalyticsRead]: 'Read performance and engagement analytics',
};
export function businessApiKeyScopeSatisfies(keyScopes, required) {
    if (keyScopes.includes(required)) {
        return true;
    }
    const [resource, verb] = required.split(':');
    if (verb === 'read') {
        return keyScopes.includes(`${resource}:write`);
    }
    return false;
}
//# sourceMappingURL=business-api-key-scope.const.js.map